/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Badge_CustomInputs */

const vi_sidebar_layout_badge_custom = /** @type {(inputs: Sidebar_Layout_Badge_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự tạo`)
};

/**

* @param {Sidebar_Layout_Badge_CustomInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_badge_custom = /** @type {((inputs?: Sidebar_Layout_Badge_CustomInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Badge_CustomInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_badge_custom(inputs)
});